import { render, staticRenderFns } from "./PlatformCapabilitiesComponents.vue?vue&type=template&id=99c5eb48&"
import script from "./PlatformCapabilitiesComponents.vue?vue&type=script&lang=js&"
export * from "./PlatformCapabilitiesComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports